import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Input, CardBody, Card } from "reactstrap";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import { dynamicImage } from "../../../Utils";
import { H4, Image, LI, ProgressBar, UL } from "../../../AbstractElements";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import FeatherIconCom from "../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { ensureDexieReady, getDataFromDexie } from "../../../db/DexieServises";
import WebCard from "../../../Utils/CommonComponents/DashboardsCommon/ProjectCommon/WebCard";
// import { webCardData } from "../../../Data/DashboardsData/ProjectData";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import CommonDropdown from "../../Buttons/Common/CommonDropdown";
import Comment_CustomerContent from "../../../Utils/CommonComponents/DashboardsCommon/ProjectCommon/WebCard/Comment&CustomerContent";
import { monthlyDropdownList } from "../../../Data/DashboardsData/ECommerceData";

const webCardData = [
    {
        id: 1,
        color: 'primary',
        icon: 'improvement',
        title: 'Web & mobile app',
        text: 'Dribble Presentation',
        comment: [
            { id: 1, icon: 'calendar', spanText: 'June 18,2023' },
            { id: 2, icon: 'message', spanText: '18' },
            { id: 3, icon: 'link', spanText: '08' },
        ],
        progressValue: 70,
    },
    {
        id: 2,
        divClass: 'nft-card',
        color: 'success',
        icon: 'NFT',
        title: 'NFT website design',
        text: 'Pinterest Promotion',
        comment: [
            { id: 1, icon: 'calendar', spanText: 'June 15,2023' },
            { id: 2, icon: 'message', spanText: '20' },
            { id: 3, icon: 'link', spanText: '10' },
        ],

        progressValue: 60,
    },
    {
        id: 3,
        divClass: 'twitter-card',
        color: 'danger',
        icon: 'management',
        title: 'Project dashboard',
        text: 'Twitter Marketing',
        comment: [
            { id: 1, icon: 'calendar', spanText: 'June 25,2023' },
            { id: 2, icon: 'message', spanText: '30' },
            { id: 3, icon: 'link', spanText: '12' },
        ],

        progressValue: 50,
    },


];
export default function FtpImport() {
    const [ftpImportBatches, setFtpImportBatches] = useState<any[]>([]);
    const [searchText, setSearchText] = useState('');
    const [displayedData, setDisplayedData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const ftpCardData = ftpImportBatches.map((item, index) => ({
        id: item.FtpImportBatchId,
        color: 'primary',  // you can dynamically set colors based on conditions
        icon: 'improvement',    // pick any icon you use
        title: item.Label || 'No Label',
        text: item.FtpPath || '',
        comment: [
            { id: 1, icon: 'calendar', spanText: item.CreatedAt?.split(' ')[0] || '' },
            { id: 2, icon: 'message', spanText: `Next Batch: ${item.NextBatch || 0}` },
            { id: 3, icon: 'link', spanText: item.AttachedFunction || '' },
        ],
        progressValue: item.Isenabled === 1 ? 100 : 0, // example logic
    }));
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');

    useEffect(() => {
        fetchFTP();
    }, []);

    const fetchFTP = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or APP_TOKEN');
            return;
        }
        await ensureDexieReady();
        const orgdata = await getDataFromDexie('OrgUnit');
        const companyId = orgdata?.[0]?.CompanyId;
        // console.log(companyId, '===============OrgUnit-> companyId ');

        setLoading(true);

        try {
            const url = `${serverUrl}${API.getFtpImportBatches}`;
            const { status, data } = await getData(url, true, { company_id: companyId });

            if (status === 200 && Array.isArray(data?.data)) {
                setFtpImportBatches(data.data);
                setDisplayedData(data.data);
            } else {
                setFtpImportBatches([]);
                setDisplayedData([]);
            }
        } catch (error) {
            console.error("❌ Failed to fetch employees:", error);
            setFtpImportBatches([]);
            setDisplayedData([]);
        } finally {
            setLoading(false);
        }
    };

    const keys = ftpImportBatches.length > 0 ? Object.keys(ftpImportBatches[0]) : [];

    const headData = keys.map((key, index) => ({
        id: `${index + 1}`,
        head: key,
        key: key,
        sortKey: key
    }));

    // 🔍 Search Logic
    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = ftpImportBatches.filter((item) =>
            keys.some(k => String(item[k])?.toLowerCase().includes(lower))
        );
        setDisplayedData(filtered);
    }, [searchText, ftpImportBatches]);

    // ⬇️ Export Logic
    const handleExportToExcel = () => {
        const exportData = displayedData.map((row: Record<string, any>) => {
            const rowData: Record<string, any> = {};
            keys.forEach(key => {
                rowData[key] = row[key];
            });
            return rowData;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'FTP Import');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `FTP_Import_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    return (<>
        {/* <div className="page-body p-3"> */}
        <Container fluid className="project-dashboard pb-2 pt-2">
            {/* <CardHeaderSpan headingClassName='pb-2 pt-0' back={true} heading={'FTP '} span={'ReportListTitle'} /> */}
            <Col xl={12} className="col-xl-100 box-col-12">
                <Row>
                    {/* <div
                        className="d-flex overflow-auto flex-nowrap"
                        style={{ gap: '15px', padding: '10px' }}
                        > */}
                    {ftpCardData.map((item) => (
                        <Col xl={4} lg={4} key={item.id}>
                            <Card className="web-card">
                                <CardBody>
                                    <div className={`d-flex`}>
                                        <div className="header-top">
                                            <div className={`mobile-app bg-light-${item.color}`}>
                                                <span></span>
                                                <SvgIcon iconId={item.icon} />
                                            </div>
                                            <div className="flex-grow-1">
                                                <H4>{item.title}</H4>
                                                <span>{item.text}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comment">
                                        <UL className='simple-list flex-row'>
                                            {item.comment.map((list) => (
                                                <LI key={list.id}>
                                                    {/* <SvgIcon iconId={list.icon} /> */}
                                                    <span>{list.spanText}</span>
                                                </LI>
                                            ))}
                                        </UL>
                                    </div>
                                    <div className="col-12">
                                        <div className="progress-value">
                                            <div className='d-flex justify-content-between'>
                                                <span>{'Progress'}</span><span>{item.progressValue}{'%'}</span>
                                            </div>
                                            <ProgressBar value={item.progressValue} color={item.color} />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}

                    {/* {webCardData.map((item) => (
                        <Col xl={4} lg={4} key={item.id}>
                            <Card className="web-card">
                                <CardBody>
                                    <div className={`d-flex ${item.divClass}`}>
                                        <div className="header-top">
                                            <div className={`mobile-app bg-light-${item.color}`}>
                                                <span></span>
                                                <SvgIcon iconId={item.icon} />
                                            </div>
                                            <div className="flex-grow-1">
                                                <H4>{item.title}</H4>
                                                <span>{item.text}</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="comment">
                                        <UL className='simple-list flex-row'>
                                            {item.comment.map((list) => (
                                                <LI key={list.id}>
                                                    <SvgIcon iconId={list.icon} />
                                                    <span>{list.spanText}</span>
                                                </LI>
                                            ))}
                                        </UL>
                                    </div>
                                    <div className="col-12 " >

                                        <div className="progress-value">
                                            <div className='d-flex justify-content-between'> <span>{'Progress'}</span><span>{item.progressValue}{'%'}</span></div>
                                            <ProgressBar value={item.progressValue} color={item.color} />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))} */}
                    {/* </div> */}
                </Row>

            </Col>


            {/* <Row className="align-items-center justify-content-between mb-3">
                <Col md="4">
                    <Input
                        type="text"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        placeholder="🔍 Search"
                    />
                </Col>

                <Col md="auto">
                    <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                        <FeatherIconCom iconName="Download" size={14} className="text-light" />
                        <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                    </button>
                </Col>
            </Row>

            {loading ? (
                <div className="text-center py-3">
                    <Image
                        className="b-r-10 img-80"
                        src={dynamicImage('dashboard/loader.gif')}
                        alt="Loading..."
                    />
                </div>
            ) : (
                <CommonTableNew
                    caption=""
                    headData={headData}
                    data={displayedData}
                    renderRow={(row, rowIndex) => (
                        <tr key={rowIndex}>
                            {keys.map((key, colIndex) => (
                                <td key={colIndex}>{row[key]}</td>
                            ))}
                        </tr>
                    )}
                />
            )} */}
        </Container>
        {/* </div> */}
    </>
    );
}
